import { useGlobalContext } from "../../../../../Context/Context";
import Button from "../../../../Custom/Button/Button";
import Obrazac5Prikaz from "./Obrazac5Prikaz";

const SIGNATURE_URL = "https://data.nadzor.app/potpis.jpg";

// Grupisemo sve redove po workplace_id + employee_id, kao Obrazac1
const buildGroups = (data) => {
  const groups = [];
  let i = 0;
  while (i < data.length) {
    const key = `${data[i].workplace_id}_${data[i].employee_id}`;
    let j = i;
    while (j < data.length && `${data[j].workplace_id}_${data[j].employee_id}` === key) j++;
    groups.push(data.slice(i, j));
    i = j;
  }
  return groups;
};

function Preview({ data, selectedRow, cancel, onRefresh }) {
  const { dictionary } = useGlobalContext();

  // Nadji grupu kojoj pripada selectedRow
  const groups = buildGroups(data);
  const group = groups.find(g => g.some(r => r.id === selectedRow.id)) || [selectedRow];

  const handleStampaj = () => {
    const el = document.getElementById("print-obrazac5");
    if (!el) return;
    const useSignature = window.confirm("Da li želite da dodate stranicu sa potpisom?");
    let signatureHtml = "";
    if (useSignature) {
      signatureHtml = `<div style="page-break-before:always;"><div id="sig-page" style="width:287mm;height:200mm;margin:0 auto;position:relative;overflow:hidden;background:#fff;"><img id="signature-img" src="${SIGNATURE_URL}" style="position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);display:block;"/></div></div>`;
    }
    const printWindow = window.open("", "_blank");
    if (!printWindow) { alert("Popup blokiran."); return; }
    printWindow.document.write(`<html><head><meta charset="utf-8"/><style>@page{size:A4 landscape;margin:5mm 5mm 15mm 5mm;}body{margin:0;padding:5mm;font-family:sans-serif;font-size:11px;}table{width:100%;border-collapse:collapse;}td,th{border:1px solid black;padding:3px;text-align:center;vertical-align:middle;font-size:11px;}hr{width:80%;margin:0 auto 5px;}</style></head><body>${el.innerHTML}${signatureHtml}</body></html>`);
    printWindow.document.close();
    printWindow.onload = () => {
      const doPrint = () => { printWindow.focus(); printWindow.print(); printWindow.close(); };
      const img = printWindow.document.getElementById("signature-img");
      const box = printWindow.document.getElementById("sig-page");
      if (box) {
        const footer = Array.from(printWindow.document.querySelectorAll("div"))
          .find(d => d.textContent?.includes("Саветник/сарадник") && d.textContent?.includes("Послодавац"));
        if (footer) footer.remove();
      }
      if (!img || !box) return doPrint();
      const fitAndPrint = () => {
        const nW = img.naturalWidth || 1; const nH = img.naturalHeight || 1;
        img.style.transform = `translate(-50%, -50%) rotate(${nW > nH ? -90 : 0}deg)`;
        doPrint();
      };
      if (img.complete && img.naturalWidth) fitAndPrint();
      else { img.onload = fitAndPrint; img.onerror = doPrint; }
    };
  };

  return (
    <>
      <style>{`#print-obrazac5 td, #print-obrazac5 th { font-size: 12px !important; }`}</style>
      <div id="print-obrazac5" style={{ overflowY: "auto", height: "calc(100% - 60px)", background: "white", padding: "40px", border: "1.5px solid #9f9f9f" }}>
        <Obrazac5Prikaz group={group} />
      </div>
      <div style={{ marginTop: "10px", display: "flex", justifyContent: "space-between", gap: "10px" }}>
        <div onClick={handleStampaj}>
          <Button activation={true} style={{ padding: "5px", fontWeight: "bold" }}>{dictionary["stampaj"] || "ШТАМПАЈ"}</Button>
        </div>
        <div onClick={cancel}>
          <Button activation={true} style={{ padding: "5px", fontWeight: "bold" }}>{dictionary["zatvori"] || "ЗАТВОРИ"}</Button>
        </div>
      </div>
    </>
  );
}

export default Preview;